import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
// import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import "./css/style.css";

class Congratulations extends Component {
    renderText = () => {
        if (this.props.customizableQR) {
            return (
                <React.Fragment>
                    <p style={{ fontSize: '12px', textAlign: 'left', paddingTop: '15px' }}>
                        -To view your personal message, please scan your Say More code again.<br/>
                        TIP: you can visit <a href="https://www.saymorescanner.com">saymorescanner.com</a> instead of using a QR code scanning app.
                    </p>
                    <p style={{ fontSize: '12px', textAlign: 'left' }}>
                        -To replace the personal message with a new one, please follow the instructions in your "Congratulations" email.
                    </p>
                    <a className="button" onClick={() => { this.props.history.push("/scan/" + this.props.QRCode + "/customizeExperience/" + this.props.token);}} style={{ display: 'inline-block'}}>Customize Web Experience</a>
                </React.Fragment>
            );
        }
        else if (this.props.demoQR) {
            return (
                <React.Fragment>
                    <p style={{ fontSize: '12px', textAlign: 'left', paddingTop: '15px' }}>
                        -To view your personal message, please scan your Say More code again.<br/>
                        TIP: you can visit <a href="https://www.saymorescanner.com">saymorescanner.com</a> instead of using a QR code scanning app.
                    </p>
                    <p style={{ fontSize: '12px', paddingTop: '15px', textAlign: "center" }}>
                        <div>-or-</div>
                        <a className="button" href={"/" + this.props.QRCode}>VIEW NOW</a>
                    </p>
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    <p style={{ fontSize: '12px', textAlign: 'left', paddingTop: '15px' }}>
                        -To view your personal message, please scan your Say More code again.<br/>
                        TIP: you can visit <a href="https://www.saymorescanner.com">saymorescanner.com</a> instead of using a QR code scanning app.
                    </p>
                    <p style={{ fontSize: '12px', textAlign: 'left' }}>
                        -To replace the personal message with a new one, please follow the instructions in your "Congratulations" email.
                    </p>
                    {this.renderAddAnother()}
                </React.Fragment>
            );
        }
    }
    renderAddAnother = () => {
        return (
            <React.Fragment>
                <p style={{ fontSize: '12px', paddingTop: '15px', textAlign: "center" }}>
                    <div>-or-</div>
                    <a className="button" href={"/?token=" + this.props.token}><span style={{fontSize: "smaller"}}>HAVE ANOTHER CODE?</span><br/><span style={{fontSize: "larger"}}>SCAN NOW!</span></a>
                </p>
            </React.Fragment>
        );
    }
    render() {
        return (
            <div>
                <div className="login_register">
                    <div className="container">
                        <div className="entry">
                            <div className="head">
                                <div className="logoImage"></div>
                                <div style={{ textAlign: 'center' }}>
                                    <p>Your personal message has been added!</p>
                                    <img src={require("./img/CONGRATS@2x.png")} alt='' style={{ maxHeight: "50%", maxWidth: "50%", width: 'auto', height: 'auto', margin: '0 auto' }} />
                                </div>

                                <p style={{ fontSize: '12px', textAlign: 'left', paddingTop: '15px' }}>
                                    -Please give the code a few moments to update.
                                </p>
                                {this.renderText()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default withRouter(Congratulations);



// WEBPACK FOOTER //
// ./src/components/Congratulations.js